import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/**
 * Returns today's date in the user's LOCAL timezone as YYYY-MM-DD.
 *
 * `new Date().toISOString().split("T")[0]` returns the UTC date — which for
 * users west of UTC late in the evening (or east of UTC early morning) is the
 * NEXT day, surfacing as "tomorrow" in <input type="date"> default values.
 * This helper uses local-time getters so the default always matches the
 * calendar day the user sees on their wall clock.
 */
export function todayLocalISO() {
  const d = new Date();
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

/**
 * Returns the local date `daysAgo` calendar days before today as YYYY-MM-DD.
 */
export function daysAgoLocalISO(daysAgo) {
  const d = new Date();
  d.setDate(d.getDate() - daysAgo);
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

